import { useContext, useMemo } from 'react';

import ComparisonContext from 'contexts/ComparisonContext';

// The period a block or element compares with: its own, or on a report the
// report's ('report'; none when the report has none, or when it compares to
// a fixed range). Stable across renders, it keys the comparison date scope.
const useComparisonPeriod = (
  comparison:
    | Pick<Studio.BlockComparison, 'compareType' | 'interval'>
    | undefined,
): PersistedComparisonType | undefined => {
  const { currentComparison: around } = useContext(ComparisonContext);
  const compareType = comparison?.compareType;
  const interval = comparison?.interval;
  return useMemo(() => {
    if (compareType !== 'report') {
      if (!compareType) {
        return undefined;
      }
      // Only the previous period goes back by a whole interval
      return compareType === 'previous' && interval
        ? { compareType, compareByInterval: interval }
        : { compareType };
    }
    return around &&
      (around.compareType === 'previous' || around.compareType === 'lastYear')
      ? around
      : undefined;
  }, [around, compareType, interval]);
};

export default useComparisonPeriod;
